import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SummaryImplRepository } from './summary-imp.respository';
import { SummaryRepository } from '@/core/domain/summary/repositories/summary.respository';
import { GetSummaryUseCase } from '@/core/domain/summary/usecases/getSummary.usecase';

const getSummaryUseCaseFactory = (repository: SummaryRepository) =>
    new GetSummaryUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetSummaryUseCase,
            useFactory: getSummaryUseCaseFactory,
            deps: [SummaryImplRepository],
        },
        {
            provide: SummaryRepository,
            useClass: SummaryImplRepository,
        },
    ],
})
export class SummaryDataModule {}
